export const COMPONENT_NAME = 'recommendations_list';
